<template>
  <v-container class="ma-0 pa-0">
    <v-form ref="form" v-model="valid" lazy-validation>
      <v-container class="ma-0 pa-0">
        <h1>{{$t('labels.confirmEmail')}}</h1>
        <p>
          {{ $t('application.email.confirmPage-text') }}
          <span class="email">{{ email }}</span>
          .
          {{ $t('application.email.confirmPage-text2') }}
        </p>

        <v-text-field
          v-shortkey="['enter']"
          @shortkey.native="nextStep"
          ref="email"
          v-model="code"
          prepend-icon="$sl-confirm"
          placeholder="1234"
          maxlength="4"
          :rules="[rules.required, rules.integer, rules.confirmCode]"
        ></v-text-field>
      </v-container>
      <NextButton
        class="mt-3"
        @enter="nextStep"
        :isEnterSubmit="true"
        @click="nextStep"
        :isDisabled="isImitatingUser()"
      >{{$t('labels.complete')}}</NextButton>
    </v-form>
  </v-container>
</template>

<script>
// Entryform for unknown user to become a apprentice
import API from '@/services/api.js'
import {mapActions, mapGetters} from 'vuex'
import {RulesMixin} from '@/components/mixins'
import NextButton from '@/components/Common/NextButton'
const SugarDate = require('sugar/date')

// @group Registration
// Styled Email component
export default {
  name: 'EmailConfirm',

  mixins: [RulesMixin],

  components: {NextButton},

  data: () => ({
    code: '',
    valid: true
  }),

  props: {
    //has email
    email: {
      // `'String'` /
      type: String,
      // The default value is: ` '' `
      default: ''
    }
  },

  computed: {
    ...mapGetters('currentuser', ['isImitatingUser'])
  },

  methods: {
    ...mapActions('currentuser', ['updateCurrentUser']),
    /**
     * @vuese
     * Used to go to the next step is form is valid and verify email with the code
     * @arg The argument is an integer representing application verification code
     */
    nextStep() {
      if (this.code.length == 4) {
        API.updatePerson({emailVerification: this.code})
          .then(response => {
            if (response.data.emailVerified) {
              this.updateUser(response.data.id)
            } else {
              this.$events.fire('showError', this.$t('errors.code-failure'))
            }
          })
          .catch(error => {
            this.$events.fire('showError', this.$t('errors.save-failure'))
            console.log('There was an error:', error)
          })
      } else {
        this.$events.fire('showError', this.$t('errors.save-failure'))
      }
    },
    /**
     * @vuese
     * Used to go to update user and move to step 4
     * @arg The argument is an integer representing user id
     */
    updateUser(id) {
      //Set the confirmPhone cookie with the userId for 6 montsh
      this.$cookies.set("confirmPhoneDate" + id, new SugarDate.Date().format("{yyyy}-{MM}-{dd}").raw, '6m')
      API.getPerson(id)
        .then(res => {
          /**
           * @vuese
           * Used to update local store with the current user data
           */
          this.updateCurrentUser(res.data)
          // Fire goToStep number 4
          // @arg The argument is a integer representing step number
          this.$emit('goToStep', {step: 4})
        })
        .catch(error => {
          //- User stored in localstore was not ok
          console.log('Store - failed to get user: ' + error)
          //  return dispatch("setCurrentUser", null);
        })
    }
  }
}
</script>

<style scoped>
.email {
  white-space: nowrap;
  font-weight: bold;
}
</style>